import mixpanel from 'mixpanel-browser';
import { isDev } from '@/utils/environment';
import { hasAnalyticsConsent } from '@/utils/consent';

const anonymousEvent = ({ event, properties }) => ({
  event,
  properties: {
    token: properties.token,
    distinct_id: properties.distinct_id,
    $insert_id: properties.$insert_id,
    time: properties.time
  }
});

export const initMixpanel = () => {
  mixpanel.init(process.env.MIXPANEL_TOKEN, {
    batch_requests: false,
    debug: isDev(),
    disable_persistence: true,
    hooks: { before_send_events: anonymousEvent },
    ip: false,
    opt_out_tracking_cookie_prefix: '__mp_anonymous_opt_in_out',
    save_referrer: false,
    skip_first_touch_marketing: true,
    store_google: false,
    track_marketing: false
  });
};

export const trackAnonymousMixpanelEvent = (eventName) =>
  hasAnalyticsConsent() ? undefined : mixpanel.track(eventName);
